<template>
  <ValidationObserver
    ref="formValidation"
    v-slot="{ invalid }"
    slim
  >
    <form
      ref="container"
      name="blockCallerNumber"
      role="form"
      class="form-horizontal p-t-10 p-b-10"
      novalidate
      @submit.prevent
    >
      <ValidationProvider
        v-slot="{ errors, classes }"
        rules="required"
        slim
      >
        <input
          v-model="number.phoneNumber"
          type="hidden"
          name="phoneNumber"
          :class="classes"
        >
      </ValidationProvider>

      <div
        class="form-group"
      >
        <label class="col-sm-3 col-md-3 control-label">{{ $t('SELECT_CAMPAIGN_LABEL') }}
          <a
            v-tooltip.right="$t('SELECT_CAMPAIGN_TT')"
          >
            &nbsp;&nbsp;<i class="fa fa-question-circle" />
          </a>
        </label>

        <div class="col-sm-5 col-md-3">
          <SearchableDropdown
            v-model="number.campaignId"
            :config="campaignsDropdownConfig"
            rules="required"
            disabled
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-xs-12 col-sm-3 col-md-3 control-label">{{ $t('SPECIFY_DURATION_LABEL') }}
          <a
            v-tooltip.right="$t('SPECIFY_DURATION_TT')"
          >
            &nbsp;&nbsp;<i class="fa fa-question-circle" />
          </a>
        </label>

        <div
          class="col-xs-6 col-sm-2 col-md-1"
        >
          <ValidationProvider
            v-slot="{ errors, classes }"
            rules="min_value:1"
            slim
          >
            <input
              v-model="number.expInHour"
              name="timePeriod"
              type="number"
              min="1"
              :placeholder="$t('DURATION_HOURS_UNIT')"
              class="form-control m-b-0"
              :class="classes"
            >
          </ValidationProvider>
        </div>
      </div>

      <div class="form-group">
        <div class="col-sm-offset-3 col-md-offset-3 col-md-8 col-sm-8">
          <PrimaryButton
            size="sm"
            :disabled="invalid"
            :show-loader-on-form="showLoader"
            @click="blockNumberSubmit"
          >
            {{ $t('BLOCK_NUMBER') }}
          </PrimaryButton>

          <button
            v-t="'CANCEL'"
            type="button"
            name="blockCallerNumberCancelButton"
            class="btn btn-sm btn-danger m-l-15"
            @click="$emit('closeForm')"
          />
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { isEmpty } from 'lodash';

import messages from './locales';
import PrimaryButton from '@/core/components/PrimaryButton';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';

export default {
  name: 'BlockForm',
  components: {
    SearchableDropdown,
    PrimaryButton
  },
  props: {
    phoneNumber: {
      type: String,
      default: ''
    },
    campaigns: {
      type: Array,
      default() {
        return [];
      }
    },
    campaignId: {
      type: String,
      default: ''
    },
    existingNumber: {
      type: Object,
      default() {
        return {};
      }
    },
    showLoader: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      number: {},
    };
  },

  computed: {
    campaignsDropdownConfig() {
      let campaignsSorted = [...this.campaigns];

      campaignsSorted.sort(function sortCampaigns(campaignA, campaignB) {
        if (campaignA.name < campaignB.name) { 
          return -1; 
        }
          
        if(campaignA.name > campaignB.name) { 
          return 1; 
        }
        
        return 0;
      });

      return {
        options: campaignsSorted,
        getOptionLabel: function getCampaignLabel(option) {
          return option && option.name;
        },
        placeholder: this.$t('SELECT_CAMPAIGN_PLACEHOLDER'),
        reduce: option => option.id,
      };
    }
  },

  beforeDestroy () {
    this.$emit('cacheFormData', this.number);
  },

  created () {
    this.initComponent();
  },

  methods: {
    initComponent() {
      if (isEmpty(this.existingNumber)) {
        this.number = {
          phoneNumber: this.phoneNumber || undefined,
          campaignId: this.campaignId || undefined, // TODO: Get Campaign ID
          blockAllCampaigns: false,
          blockAnonymousCallers: false,
        };
      } else {
        this.number = {...this.existingNumber};
      }
    },

    blockNumberSubmit() {
      this.$emit('submit', this.number);
    },
  },
  i18n: {
    locale: 'en',
    messages
  }
};
</script>

<style>

</style>